import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Books from './pages/Books/Books';
import BookDetail from './pages/Books/BookDetail';
import AddBook from './pages/AddBook/AddBook';
import Categories from './pages/Categories/Categories';
import Users from './pages/Users/Users';
import Analytics from './pages/Analytics/Analytics';

function App() {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Navigate to="/dashboard" replace />
              </ProtectedRoute>
            } />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/books" element={
              <ProtectedRoute>
                <Books />
              </ProtectedRoute>
            } />
            
            <Route path="/books/:id" element={
              <ProtectedRoute>
                <BookDetail />
              </ProtectedRoute>
            } />
            
            <Route path="/add-book" element={
              <ProtectedRoute>
                <AddBook />
              </ProtectedRoute>
            } />
            
            <Route path="/edit-book/:id" element={
              <ProtectedRoute requireAdmin>
                <AddBook />
              </ProtectedRoute>
            } />
            
            <Route path="/categories" element={
              <ProtectedRoute requireAdmin>
                <Categories />
              </ProtectedRoute>
            } />
            
            <Route path="/users" element={
              <ProtectedRoute requireAdmin>
                <Users />
              </ProtectedRoute>
            } />
            
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } />
            
            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 